export class User {
    id: number;
    prenom: string;
    nom: string;
    email: string;
    password: string;
    role_id: number;

    public constructor(init?: Partial<User>) {
        Object.assign(this, init);
    }
}
